import React from 'react';
import { Link } from 'react-router-dom';
import './Contact.css';

const Contact = () => {
  return (
    <div className="contact-page">
      <nav className="contact-nav">
        <Link to="/" className="nav-logo">Three Plates</Link>
        <div className="nav-links">
          <Link to="/" className="nav-link">Home</Link>
          <Link to="/about" className="nav-link">About</Link>
          <Link to="/contact" className="nav-link active">Contact</Link>
        </div>
      </nav>

      <div className="contact-content">
        <div className="contact-info">
          <h1>Get in Touch</h1>
          <p>Have questions about Three Plates? We'd love to hear from you.</p>

          <div className="contact-details">
            <div className="contact-detail">
              <div className="detail-icon">📧</div>
              <div>
                <h3>Email</h3>
                <p><a href="mailto:threeplatesinfo@gmail.com">threeplatesinfo@gmail.com</a></p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <footer className="contact-footer">
        <p>&copy; 2026 Three Plates. All rights reserved.</p>
      </footer>
    </div>
  );
};

export default Contact;
